<template>
  <th
    :class="{
      active: columnAttribute && sortBy === columnAttribute,
      down: sortOrder === 'desc',
      'align-left': align === 'left',
      'align-right': align === 'right',
    }"
    :style="!columnAttribute && 'cursor: unset'"
    scope="col"
    @click="updateSort"
  >
    <FlexComponent align="baseline" :gap="4" :justify="align === 'right' ? 'flex-end' : 'flex-start'">
      <TypographyComponent variant="label-large">
        {{ label }}
      </TypographyComponent>
      <el-icon :size="24" alt="sort svg">
        <ChevronIcon />
      </el-icon>
    </FlexComponent>
  </th>
</template>

<script lang="ts">
import ChevronIcon from '@/assets/icons/chevron.svg?component'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import TypographyComponent from '@/ui-library/atoms/TypographyComponent/TypographyComponent.vue'

export default {
  components: {
    FlexComponent,
    TypographyComponent,
    ChevronIcon,
  },
  props: {
    align: { type: String, default: 'left' },
    label: { type: String, required: true },
    sortBy: { type: String },
    sortOrder: {
      type: String,
      validator: (prop: string) => ['desc', 'asc'].includes(prop),
    },
    columnAttribute: { type: String },
    onUpdateSort: { type: Function },
  },
  methods: {
    updateSort() {
      if (this.onUpdateSort) {
        const invertSort = this.columnAttribute === this.sortBy
        let sortOrder = 'desc'
        if (invertSort) {
          sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc'
        }
        this.onUpdateSort({ sortBy: this.columnAttribute, sortOrder })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
th {
  border: 0;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  padding-bottom: 8px;
  text-align: center;
  &:first-child {
    text-align: left;
  }
  i {
    display: none;
    svg {
      transition: all 0.3s;
    }
  }
  &.active {
    i {
      display: inline-block;
      svg {
        transform: rotate(180deg);
      }
    }
    &.down {
      i {
        svg {
          transform: rotate(360deg);
        }
      }
    }
  }
}
</style>
